import React, { useState, useContext, useEffect, useRef, useCallback } from "react";
import { NavLink } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import StockReport from "./StockReport";

//pages & includes
import ManageSidebar from "../ManageSidebar";

//functions
import {
  _t,
  getCookie,
  pagination,
  formatPrice,
  currencySymbolLeft,
  currencySymbolRight,
  checkPermission
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//3rd party packages
import { Helmet } from "react-helmet";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import { MdDelete } from 'react-icons/md';

//context consumer
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import ViewAccountSheet from "../../accounts/transactions/ViewAccountSheet"
import DataTable from "../../../../common/DataTable";

const PurchaseReturnList = () => {
  const { t } = useTranslation();
  //getting context values here

  let {
    //ingredient purchases
    purchaseReturnHistory,
    setPurchaseReturnHistory,
    setPaginatedPurchaseReturn,
    purchaseHistoryReturnForSearch,
    setPurchaseHistoryReturnForSearch,

    //common
    loading,
    setLoading,
    
    //pagination
    dataPaginating,
  } = useContext(RestaurantContext);

  let { authUserInfo, getSupplier, supplierForSearch } = useContext(UserContext);
  // States hook here
  const [ledgerData, setLedgerData] = useState({
    modal: false,
    ledger: null
  });

  const [btnDisable, setBtnDisable] = useState("");

  //search result
  let [searchedPurchaseReturn, setSearchedPurchaseReturn] = useState({
    list: null,
    searched: false,
  });

  const searchRef = useRef(null);

  //useEffect == componentDidMount
  useEffect(() => {
    if(!supplierForSearch){
      getSupplier();
    } 
  
    setPaginatedPurchaseReturn(1)
  
  }, []);

  //search purchase here
  const handleSearch = (e) => {
    let searchInput = e.target.value.toLowerCase();
    if (searchInput.length === 0) {
      setSearchedPurchaseReturn({ ...searchedPurchaseReturn, searched: false });
    } else {
      const searchedList = purchaseHistoryReturnForSearch.filter((item) => {
        //name
        let lowerCaseItemSupplierName = item?.supplier_name && item.supplier_name.toLowerCase();
        //email
        let lowerCaseItemInvoice = item.invoice_number && item.invoice_number.toLowerCase();
        let lowerCaseBranch = item.branch?.name && item.branch.name.toLowerCase();

        return (
          (lowerCaseItemSupplierName && lowerCaseItemSupplierName.includes(searchInput)) ||
          lowerCaseItemInvoice.includes(searchInput) ||
          (lowerCaseBranch && lowerCaseBranch.includes(searchInput))
        );
      });
      setSearchedPurchaseReturn({
        ...searchedPurchaseReturn,
        list: searchedList,
        searched: true,
      });
    }
  };

  //delete confirmation modal of waiter
  const handleDeleteConfirmation = (id) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="card card-body">
            <h1>{_t(t("Are you sure?"))}</h1>
            <p className="text-center">{_t(t("You want to delete this?"))}</p>
            <div className="d-flex justify-content-center">
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleDeletePurchase(id);
                  onClose();
                }}
              >
                {_t(t("Yes, delete it!"))}
              </button>
              <button className="btn btn-success ml-2 px-3" onClick={onClose}>
                {_t(t("No"))}
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const handleSetResponse = useCallback((data) => {
    setPurchaseReturnHistory(data[0]);
    setPurchaseHistoryReturnForSearch(data[1]);
    setSearchedPurchaseReturn({
      ...searchedPurchaseReturn,
      list: data[1],
    });
  }, [])

  //delete purchase here
  const handleDeletePurchase = (id) => {
    setLoading(true);
    const url = BASE_URL + `/settings/purchase-return/${id}`;
    return axios
      .delete(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        handleSetResponse(res.data)
        setLoading(false);
        toast.success(`${_t(t("Purchase has been deleted successfully"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      })
      .catch(() => {
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`, {
          position: "bottom-center",
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
      });
  };

  //print bills states and function
  const [newRow,setNewRow]=useState([]);
  const [purchaseDate,setPurchaseDate]=useState(new Date());
  let [newItem, setNewItem] = useState({
    branch: null,
    supplier: null,
    invoice: "",
    description: "",
    paymentType: "",
  });
  const componentRef = useRef();
  const handleOnlyPrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const handlePiLedger = async(id) =>{
    const url = BASE_URL + "/settings/check-financial-ledger-view/" + parseInt(id) + "/PI";
    try{
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
      if(res.data){
        setLedgerData({ modal: true, ledger: res.data});
      }
    }catch(err){
      console.log("error==>",err)
    }
  }
  
  const handleGetPrintData = async(id) => {
    const url =
    BASE_URL + "/settings/purchase-return/" + parseInt(id);
    try {
      const res = await axios
        .get(url, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        });
        if(res.data){
          const editPurchase = res.data;
          const purchaseDate = new Date(editPurchase.document_date);
          setPurchaseDate(purchaseDate);
          setNewItem({
            ...newItem,
            invoice: editPurchase.invoice_number,
            branch:{
              id: editPurchase.branch_id,
              name: editPurchase.branch_name
            },
            supplier: {
              id: editPurchase.supplier_id,
              name: editPurchase.supplier_name
            },
            paymentType: editPurchase.payment_type,
            description: editPurchase.desc,
            manual_invoice_no: editPurchase.manual_invoice_no ?? "",
            total_amount: editPurchase.total_amount,
            total_discount: editPurchase.total_discount,
            total_tax: editPurchase.total_tax,
            total_bill: editPurchase.total_bill,
          });
          const newArr=[];
          if(editPurchase?.purchase_return_details && editPurchase.purchase_return_details.length>0){
            editPurchase.purchase_return_details.map((item)=>{
              newArr.push({
                ...item,
                unit_id: item.unit.id,
                unit_name: item.unit.name,
                base_unit: item.base_unit.id,
              })
            })
          }
          setNewRow([...newArr])
        }
        handleOnlyPrint();
        
    } catch(error) {
      console.log("error==>",error)
    }
  }

  const handleGetAmount = (index) => {
    let qty = 0;
    let rate = 0;
    if (newRow !== null && newRow[index].qty !== "") {
      qty = parseFloat(newRow[index].qty);
    }
    if (newRow !== null && newRow[index].rate !== "") {
      rate = parseFloat(newRow[index].rate);
    }
    return rate * qty;
  };

  //post button function
  const handlePostApi = async (id) => {
    // setLoading(true);
    const url = BASE_URL + "/settings/mark-is-post-preturn";
    setBtnDisable(id)
    let formData = new FormData();
    formData.append('id',id)
    formData.append('is_post',1)
    try {
      const res = await axios.post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      });
        if(res.data){
          setBtnDisable("")
          handleSetResponse(res.data)
          toast.success(`${_t(t("Purchase Invoice has been post"))}`,{
            position: "bottom-center",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            className: "text-center toast-notification",
          });
        }
        setLoading(false);
    } catch {
      setLoading(false);
      setBtnDisable("")
      toast.error(`${_t(t("Please try again"))}`,{
        position: "bottom-center",
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
    }
  }

  const handleFetchData = (page) => {
    setPaginatedPurchaseReturn(page);
  };

  const getListData = useCallback(() => {
    if (searchedPurchaseReturn.searched) {
      return searchedPurchaseReturn.list;
    }
    return purchaseReturnHistory?.data || [];
  }, [searchedPurchaseReturn, purchaseReturnHistory]);

  const onClearSearch = () => {
    setSearchedPurchaseReturn({ ...searchedPurchaseReturn, searched: false });
    if (searchRef.current) {
      searchRef.current.value = "";
    }
  }

  const COLUMNS = [
    { label: "S/L", render: (item, i) => i + 1 },
    { label: "Supplier", key: "supplier_name" },
    { label: "Invoice", key: "invoice_number" },
    { label: "Purchased", render: (item) => <Moment format="DD-MMMM-YYYY">{item.document_date}</Moment> },
    { label: "Branch", key: "branch_name" },
    {
      label: "Total", render: (item) => (
        <>
          {currencySymbolLeft()}
          {formatPrice(item.total_bill)}
          {currencySymbolRight()}
        </>
      )
    },
    {
      label: "Action", render: (item) => (
        <div className="d-flex justify-content-center">
          {item.is_post !== 1 && (
            <>
              <NavLink
                disabled={item.id === btnDisable}
                className="btn btn-primary ml-2 rounded-sm"
                to={`/dashboard/manage/stock/purchase-return-edit/${item.id}`}
                style={{ height: "1.7rem", width: "1.7rem" }}
              >
                <div className="d-flex align-items-center justify-content-center">
                  <i className="fa fa-pencil edit-icon" aria-hidden="true"></i>
                </div>
              </NavLink>
              <button
                disabled={item.id === btnDisable}
                className="btn btn-danger ml-2 rounded-sm del-btn"
                onClick={() => handleDeleteConfirmation(item.id)}
              >
                <MdDelete className="del-icon" />
              </button>
            </>
          )
          }
          {authUserInfo.permissions !== null && authUserInfo.permissions.includes("Accounts") &&
            item.is_post === 1 && (
              <button
                className="btn btn-primary ml-2 rounded-sm del-btn"
                onClick={() => handlePiLedger(item.id)}
              >
                <i className="fa fa-eye" aria-hidden="true"></i>
              </button>
            )
          }
          <button
            className="btn btn-secondary ml-2 rounded-sm del-btn"
            onClick={() => handleGetPrintData(item.id)}
          >
            <i className="fa fa-print edit-icon"></i>
          </button>
          {(checkPermission(authUserInfo.permissions, "PR Post") && item.is_post !== 1 ? <button
            className="btn btn-dark ml-2 rounded-sm del-btn"
            title="Post PI"
            style={{ padding: "1px 0px 0px 1px" }}
            disabled={loading || item.id === btnDisable}
            onClick={() => handlePostApi(item.id)}
          >
            <i className="fa fa-check-square-o" aria-hidden="true"></i>
          </button> : null)
          }
        </div>
      )
    },
    { label: "Created Date", render: (item) => <Moment format="DD-MMMM-YYYY hh:mm A">{item.created_at}</Moment> },
  ];

  return (
    <>
      <Helmet>
        <title>{_t(t("Ingredient Purchase Return"))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
          {/* left Sidebar */}
          <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
            <ManageSidebar />
          </div>
          {/* left Sidebar ends */}

          {/* Rightbar contents */}
          <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
            <div className="t-bg-white">
              <div key="fragment3">
                <div className="row mx-3 gx-2 align-items-center t-pt-15 t-pb-15">
                  <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                    <ul className="t-list fk-breadcrumb">
                      <li className="fk-breadcrumb__list">
                      <span className="t-link fk-breadcrumb__link text-capitalize">
                        {!searchedPurchaseReturn.searched
                        ? _t(t("Purchase Return List"))
                        : _t(t("Search Result"))}
                      </span>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6 col-lg-7">
                    <div className="row gx-3 align-items-center">
                      {/* Search customer */}
                      <div className="col-md-9 t-mb-15 mb-md-0">
                        <div className="input-group">
                          <div className="form-file">
                          <input
                            ref={searchRef}
                            type="text"
                            className="form-control border-0 form-control--light-1 rounded-left"
                            placeholder={_t(t("Search")) + ".."}
                            onChange={handleSearch}
                          />
                          </div>
                          <button
                          className="btn btn-primary rounded-right"
                          type="button"
                          >
                          <i
                            className="fa fa-search"
                            aria-hidden="true"
                          ></i>
                          </button>
                        </div>
                      </div>

                      {/* Add customer modal trigger button */}
                      <div className="col-md-3 text-md-right">
                        <NavLink
                          to="/dashboard/manage/stock/purchase-return-add"
                          className="btn btn-primary xsm-text text-uppercase btn-lg btn-block rounded"
                        >
                          {_t(t("add new"))}
                        </NavLink>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Table */}
                <DataTable
                  loading={loading || dataPaginating}
                  data={getListData()}
                  columns={COLUMNS}
                  emptyText="No data available"
                  pagination={{
                    isPageLoading: loading,
                    isPagination: true,
                    pageCount: purchaseReturnHistory?.last_page,
                    currentPage: purchaseReturnHistory?.current_page,
                    from: purchaseReturnHistory?.from,
                    to: purchaseReturnHistory?.to,
                    total: purchaseReturnHistory?.total,
                  }}
                  handleFetchData={handleFetchData}
                  searchPayload={{
                    isSearched: searchedPurchaseReturn.searched,
                    onClearSearch
                  }}
                />
              </div>
            </div>
          </div>
          {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
      <StockReport
        name = "Purchase Return"
        purchaseDate={purchaseDate}
        newItem={newItem}
        newRow={newRow}
        invoiceNo = {"Invoice No"}
        inoviceDate = {"Invoice Date"}
        handleGetTotal={""}
        handleAmount={""}
        handleTaxAmount={""}
        handleDisAmount={""}
        handleGetSubTotal={""}
        handleGetAmount={handleGetAmount}
        stockPrint={componentRef}
      /> 
      <ViewAccountSheet
        accountLedger={ledgerData}
        setAccountLedger= {setLedgerData}
      />
    </>
  );
};

export default PurchaseReturnList;
